import styled from "styled-components";

interface ITag {
  color?: string
}

export const TagsContainer = styled.div`
  margin: 36px auto 0;
  
  @media (min-width: 1280px) {
    width: 1200px;
  }

  @media (min-width: 980px) {
    margin: 80px auto 0;
  }
`

export const TagsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin: -10px -25px 0;
`

export const TagWrapp = styled.div`
  padding: 10px 5px;

  @media (min-width: 980px) {
    padding: 10px 17px;
  }
`

export const Tag = styled.div<ITag>`
  padding: 10px;
  font-weight: 600;
  font-size: 14px;
  line-height: 160%;
  text-align: center;
  color: #2A2637;
  background: ${({ color }) => color && color || '#fff'};
  border-radius: 100px;

  @media (min-width: 980px) {
    padding: 15px;
    font-weight: 500;
    font-size: 16px;
  }
`